const isIOS = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

const downloadFile = async (url, filename = 'arquivo.pdf') => {
  // iOS Safari ignora o atributo download em blob URLs — abre a URL direta
  // para que o Content-Disposition: attachment do S3 force o download
  if (isIOS()) {
    // window.open bloqueado no iOS Safari quando chamado após await (contexto de gesto perdido)
    // window.location.href não é popup — não é bloqueado; com Content-Disposition:attachment no S3, faz download sem navegar
    window.location.href = url;
    return;
  }

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error('fetch failed');
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
  } catch {
    window.open(url, '_blank');
  }
};

export default downloadFile;
